module.exports = __webpack_public_path__ + "1f211fe9cc3b7dbea9dcfcdccb2e3c52.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-25.png
 ** module id = 1016
 ** module chunks = 0
 **/